module.exports = __webpack_public_path__ + "static/media/icon_playground_marker_store.2070548f.svg";